// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__bSfJV","title":"Header_title__2odoE","left":"Header_left__153kR","clinicName":"Header_clinicName__pbCPf"};